import { GetServerSideProps } from "next";

import { getFeaturedImage, getNavigation, getWine } from "@/api/functions";
import { Wine, WP_Image } from "@/models";
import WineDetailTemplate from "@/templates/wineDetail";
import { AddToCartButton } from "@/components/AddToCartButton/AddToCartButton";
import dynamic from "next/dynamic";
import { WP_Navigation } from "@/models/menu";
import WithSWRConfig from "@/layouts/WithSWRConfig";
import { useRef } from "react";

const DynamicShoppingCart = dynamic(() => import("@/components/ShoppingCart"), {
	ssr: false,
});

interface ServerSideProps {
	slug: string;
	wine: Wine;
	domain: string | null;
	url: string | null;
	fallback: {
		[key: string]: WP_Navigation | Wine | WP_Image | null;
	};
}

export const getServerSideProps: GetServerSideProps<ServerSideProps> = async (
	context
) => {
	const wineId = context.params?.wineId as string;
	const navigation = await getNavigation();
	const wine = await getWine(context.params?.wineId as string);

	// Fetch front page illustration
	const featuredImage = wine?.featured_media
		? await getFeaturedImage(wine?.featured_media)
		: null;
	const illustration = wine?.acf.illustration
		? await getFeaturedImage(wine?.acf.illustration)
		: null;

	return {
		props: {
			slug: wineId,
			wine,
			// featuredImage,
			// illustration,
			domain: context.req.headers.host! ?? null,
			url: context.req.headers.referer! ?? null,
			fallback: {
				"/wsw/v1/menu": navigation,
				[`/wsw/v1/wine/${wineId}`]: wine,
				[`/wp/v2/media/${wine.featured_media}`]: featuredImage,
				[`/wp/v2/media/${wine.acf.illustration}`]: illustration,
			},
			key: wineId,
		},
	};
};

export default function WineDetailPage({
	slug,
	wine,
	domain,
	url,
	fallback,
}: ServerSideProps) {
	const portalRef = useRef<HTMLDivElement | null>(null);

	return (
		<WithSWRConfig fallback={fallback}>
			<WineDetailTemplate
				slug={slug}
				domain={domain || undefined}
				url={url || undefined}
			/>
			<AddToCartButton wine={wine} portalRef={portalRef} />
			<DynamicShoppingCart />
			<div id="portal" ref={portalRef} />
		</WithSWRConfig>
	);
}
